import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../environments/environment';
import jwt_decode from 'jwt-decode';
import { FunctionsService } from 'src/app/services/functions.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { OkModalComponent } from '../generic-components/ok-modal/ok-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { NoButtonModalComponent } from '../generic-components/no-button-modal/no-button-modal.component';
import { Message } from 'src/app/message/message';
import { ApiService } from '../api.service';
@Injectable({
	providedIn: 'root'
})
export class SignalRService {
    private message$: Subject<Message>;
    public connection: signalR.HubConnection;
	modalOptions: NgbModalOptions = {};
	modalRef:any;
	constructor(public functionsService:FunctionsService, private modalService: NgbModal,  private translate: TranslateService, private apiService: ApiService) { 
		this.message$ = new Subject<Message>();
        
	}

	public status() {
		console.log(this.connection.connectionId);
	}

	public connect() {
		this.connection = new signalR.HubConnectionBuilder().configureLogging(signalR.LogLevel.Debug).withUrl(environment.api + "alerter", {skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets }).withAutomaticReconnect().build();
		this.connection.start().then(async () => {
			console.log('Connection started!');
			var orgId = localStorage.getItem('orgId');
		this.connection.invoke("AddToGroup", orgId).then( t=>{
			});
		})
        .catch(() => {
			this.connection.stop();
			console.log('Error while establishing connection :(');
		});

		this.connection.onreconnecting(() => {
			this.modalOptions.backdrop = 'static';
            this.modalOptions.keyboard = false;
            this.modalOptions.size = 'lg';
            this.modalRef = this.modalService.open(NoButtonModalComponent, this.modalOptions);
            this.modalRef.componentInstance.title = this.translate.instant('error.reconnect_attempt');
			this.modalRef.componentInstance.message = this.translate.instant('error.reconnect_attempt_message');
		});

		this.connection.on('ReceiveMessage', (message) => {
			console.log('receive message');
			console.log(message);
		});

		this.connection.onclose(()=>{
			if((!localStorage.getItem("signOut") || localStorage.getItem("signOut")=="0") && (localStorage.getItem("signOut")!="2")){
				this.modalOptions.backdrop = 'static';
				this.modalOptions.keyboard = false;
				this.modalOptions.size = 'lg';
				this.modalRef = this.modalService.open(OkModalComponent, this.modalOptions);
				this.modalRef.componentInstance.title = this.translate.instant('error.connection_closed');
				this.modalRef.componentInstance.message = this.translate.instant('error.connection_closed_message');
				this.modalRef.result.then(() => {
					this.modalService.dismissAll();
					this.functionsService.signOut();
				});
			}
		});
		this.connection.onreconnected(()=>{
			this.modalService.dismissAll();
			var orgId = localStorage.getItem('orgId');
			this.connection.invoke("AddToGroup", orgId).then( t=>{
			});
		});

		this.connection.on('SendMessage', (message) => {
			console.log('this.connection.on');
			this.message$.next(message);
		});

		this.connection.on('OnConnected', (message) => {
			console.log('this.connection.on');
		});
	}

	public getMessage(): Observable<Message> {
		return this.message$;
	}

	public disconnect() {
		this.connection.stop();
	}
}
